// Debug adapter for local development with Node.js
// This file is used by edge.libx.js's localServer.js helper
// Run with: tsx node_modules/edge.libx.js/build/helpers/localServer.js src/worker/adapters/debug.ts

import { serverAdapter } from '../@worker';
import { libx } from 'libx.js/build/bundles/essentials.js';
import { LogLevel } from 'libx.js/build/modules/log';

// Enable verbose logging for debug
libx.log.filterLevel = LogLevel.All;
libx.log.isConsole = true;

// Export format required by edge.libx.js localServer
export const handler = serverAdapter.fetch;
export const prefix = '';

